// src/types/index.ts

// Тип повторения
export type RepeatType = 'DAILY' | 'WEEKLY' | 'BIWEEKLY' | 'MONTHLY';

// Правило повторения
export interface RepeatRule {
    enabled: boolean;
    type: RepeatType;
    until: string;  // ISO дата "YYYY-MM-DD"
}


// Ученик
export interface Student {
    id: number;
    fullName: string;
    phone?: string | null;
    vk?: string | null;
    telegram?: string | null;
    email?: string | null;
    pricePerLesson: number;
    groupId?: number | null;
    isActive: boolean;
    hasAccount?: boolean;
    createdAt: string;
    updatedAt: string;
}

// Группа
export interface Group {
    id: number;                // BIGINT -> number
    name: string;
    studentIds: number[];      // BIGINT -> number[]
    createdAt: string;
    updatedAt: string;
}

// Урок — добавляем seriesId
export interface Lesson {
    id: number;
    seriesId?: number | null;      // НОВОЕ
    studentId?: number;
    groupId?: number;
    date: string;
    startTime: string;
    endTime: string;
    timezone: string;
    topic: string;
    recordingLink?: string;
    homeworkLink?: string;
    isFree?: boolean;
    createdAt: string;
    updatedAt: string;
}

// ApiResponse остается без изменений
export interface ApiResponse<T> {
    success: boolean;
    data?: T;
    error?: string;
}

// Дополнительный тип для создания ученика (без id и системных полей)
export interface CreateStudentDto {
    fullName: string;
    phone?: string | null;
    vk?: string | null;
    telegram?: string | null;
    email?: string | null;
    pricePerLesson: number;
    groupId?: number | null;
    isNeedAccount?: boolean;
}

// Ответ при создании студента
export interface CreateStudentResponse {
    student: Student;
    invitationToken?: string | null;
    invitationExpiresAt?: string | null;
}

// Информация о приглашении
export interface Invitation {
    id: number;
    token: string;
    studentId: number;
    expiresAt: string;
    usedAt?: string | null;
    createdAt: string;
}

// Валидация токена
export interface InvitationValidation {
    valid: boolean;
    studentId: number;
    studentFullName: string;
    studentPhone?: string | null;
    studentTelegram?: string | null;
    studentVk?: string | null;
    expiresAt: string;
}

// Дополнительный тип для обновления ученика (все поля опциональны)
export interface UpdateStudentDto {
    fullName?: string;
    phone?: string;
    vk?: string | null;
    telegram?: string | null;
    email?: string | null;
    pricePerLesson?: number;
    groupId?: number | null;
    isActive?: boolean;        // Для деактивации

}

// Дополнительный тип для создания группы
export interface CreateGroupDto {
    name: string;
    studentIds?: number[];
}

// Дополнительный тип для создания урока
// DTO для создания урока
// DTO для создания урока — добавляем repeat
export interface CreateLessonDto {
    studentId?: number;
    groupId?: number;
    date: string;
    startTime: string;
    endTime: string;
    timezone: string;
    topic: string;
    recordingLink?: string | null;
    homeworkLink?: string | null;
    isFree?: boolean;
    repeat?: RepeatRule;           // НОВОЕ
}

// Ответ при создании серии
export interface CreateLessonSeriesResponse {
    seriesId: number;
    lessons: Lesson[];
}

// Настройки приложения
export interface AppSettings {
    // Профиль репетитора
    tutorName: string;
    tutorEmail: string;
    tutorPhone: string;

    // Настройки приложения
    dateFormat: string;            // Формат даты

    // Внешний вид
    theme: 'light' | 'dark';       // Тема оформления
}

// Настройки по умолчанию
export const defaultSettings: AppSettings = {
    tutorName: '',
    tutorEmail: '',
    tutorPhone: '',
    dateFormat: 'dd.MM.yyyy',
    theme: 'light',
};

// DTO для обновления серии
export interface UpdateLessonSeriesDto {
    startTime?: string;
    endTime?: string;
    topic?: string;
    date?: string;
    timezone?: string;
    studentId?: number | null;       // ← ДОБАВИТЬ
    groupId?: number | null;         // ← ДОБАВИТЬ
    isFree?: boolean;
    applyTo: 'all' | 'future';
}

// Ответ при обновлении серии
export interface UpdateLessonSeriesResponse {
    seriesId: number;
    updatedCount: number;
    lessons: Lesson[];
}

export interface User {
    id: number;
    email: string;
    fullName: string;
    phoneNumber: string;
    telegram: string;
    roles: string[];
    studentId?: number | null;   // ← добавить
    mustChangePassword?: boolean;
}

// DTO для смены пароля
export interface ChangePasswordRequest {
    currentPassword: string;
    newPassword: string;
}

// Данные для регистрации
export interface RegisterRequest {
    password: string;
    email: string;
    fullName: string;
    phoneNumber: string;
    telegram?: string;
    vk?: string;
    invitationToken: string;   // ← НОВОЕ
}

// Данные для логина (form-data)
export interface LoginRequest {
    username: string;
    password: string;
}